import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);

		this.container = document.getElementById("ajax-posts");
		this.loadMoreBtn = document.getElementById("load-more");
		this.type = this.loadMoreBtn.dataset.type;
		this.currentPage = parseInt(this.loadMoreBtn.dataset.page);
		this.maxPages = parseInt(this.loadMoreBtn.dataset.max);
		this.isLoading = false;
		this.loadingText = this.loadMoreBtn.dataset.loading;
		this.loadText = this.loadMoreBtn.dataset.load;
		this.currentLanguage = document.documentElement.lang;
	}

	init() {
		console.log('paso por more');
		this.loadMoreBtn.addEventListener("click", () => this.loadMore());
		this.loadSavedPosts();
	}

	

	loadSavedPosts() {
		// Verificamos que los posts guardados sean del mismo tipo
		const savedType = sessionStorage.getItem('savedType');
		const savedPath = sessionStorage.getItem('savePath');

		if (savedType === this.type && savedPath === window.location.pathname) {
				const savedPosts = sessionStorage.getItem('savedPosts');
				const savedPage = sessionStorage.getItem('savedPage');
				const savedLanguage = sessionStorage.getItem('savedLanguage');

				if (savedPosts && savedPage && savedLanguage) {
						this.container.innerHTML = savedPosts;
						this.currentPage = parseInt(savedPage);
						this.currentLanguage = savedLanguage;
				}
		}
	}

	async loadMore() {
		if (this.isLoading || this.currentPage >= this.maxPages) return;

		this.isLoading = true;
		this.loadMoreBtn.textContent = this.loadingText;

		try {
			const response = await fetch(art.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: `action=load_more_posts&page=${this.currentPage + 1}&type=${this.type}`,
			});

			if (!response.ok) throw new Error('Network response was not ok');

			const data = await response.json();

			if (data.success) {
				this.container.insertAdjacentHTML('beforeend', data.data.html);
				this.currentPage++;
				this.loadMoreBtn.dataset.page = this.currentPage;

				this.saveCurrentState();

				if (this.currentPage >= this.maxPages) {
					this.loadMoreBtn.style.display = 'none';
				}
			}
		} catch (error) {
			console.error('Error loading more posts:', error);
		} finally {
			this.isLoading = false;
			this.loadMoreBtn.textContent = this.loadText;
		}
	}

	saveCurrentState() {
		sessionStorage.setItem('savedPosts', this.container.innerHTML);
		sessionStorage.setItem('savedPage', this.currentPage);
		sessionStorage.setItem('savedLanguage', this.currentLanguage);
		sessionStorage.setItem('savePath', window.location.pathname);
		sessionStorage.setItem('savedType', this.type);
	}
}